// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const CloseQuote_Filled_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M10.875 6.75V15a4.505 4.505 0 0 1-4.5 4.5.75.75 0 0 1 0-1.5 3 3 0 0 0 3-3v-.75H3.75a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h5.625a1.5 1.5 0 0 1 1.5 1.5Zm9.375-1.5h-5.625a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625V15a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.505 4.505 0 0 0 4.5-4.5V6.75a1.5 1.5 0 0 0-1.5-1.5Z',
  viewBox: '0 0 24 24',
  glyph: 'CloseQuote_Filled_Stroke2_Corner0_Rounded',
})

export const CloseQuote_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M9.375 5.25H3.75a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625V15a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.505 4.505 0 0 0 4.5-4.5V6.75a1.5 1.5 0 0 0-1.5-1.5Zm0 7.5H3.75v-6h5.625Zm10.875-7.5h-5.625a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625V15a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.505 4.505 0 0 0 4.5-4.5V6.75a1.5 1.5 0 0 0-1.5-1.5Zm0 7.5h-5.625v-6h5.625Z',
  viewBox: '0 0 24 24',
  glyph: 'CloseQuote_Stroke2_Corner0_Rounded',
})

export const CloseQuote_Stroke2_Corner1_Rounded = createSinglePathSVG({
  path: 'M9.375 5.25H3.75a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625V15a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.505 4.505 0 0 0 4.5-4.5V6.75a1.5 1.5 0 0 0-1.5-1.5Zm0 7.5H3.75v-6h5.625Zm10.875-7.5h-5.625a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625V15a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.505 4.505 0 0 0 4.5-4.5V6.75a1.5 1.5 0 0 0-1.5-1.5Zm0 7.5h-5.625v-6h5.625Z',
  viewBox: '0 0 24 24',
  glyph: 'CloseQuote_Stroke2_Corner1_Rounded',
})
